module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Bold.eot?v=2c0ce49f62ac8b448635ca6666c6beb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Bold.eot?
// module id = 641
// module chunks = 0